module.exports = __webpack_public_path__ + "img/logo_login.24e0c323.png";